import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const FinancialReview: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <SvgIcon
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7 7.57895C11.7 7.05789 12.105 6.63158 12.6 6.63158C13.095 6.63158 13.5 7.05789 13.5 7.57895C13.5 8.1 13.095 8.52632 12.6 8.52632C12.105 8.52632 11.7 8.1 11.7 7.57895ZM5.4 6.63158H9.9V4.73684H5.4V6.63158ZM18 5.21053V11.8137L15.462 12.7042L13.95 18H9V16.1053H7.2V18H2.25C2.25 18 0 9.98526 0 7.10526C0 4.22526 2.214 1.89474 4.95 1.89474H9.45C10.269 0.748421 11.574 0 13.05 0C13.2724 4.98222e-05 13.4914 0.0580181 13.6873 0.168739C13.8833 0.279459 14.0502 0.439493 14.1731 0.634577C14.2961 0.829661 14.3713 1.05374 14.392 1.28683C14.4128 1.51993 14.3784 1.7548 14.292 1.97053C14.166 2.29263 14.058 2.66211 14.004 3.06L16.047 5.21053H18ZM16.2 7.10526H15.3L12.15 3.78947C12.15 3.17368 12.231 2.56737 12.384 1.98C11.511 2.21684 10.8 2.89895 10.503 3.78947H4.95C3.213 3.78947 1.8 5.27684 1.8 7.10526C1.8 8.88632 2.898 13.4053 3.6 16.1053H5.4V14.2105H10.8V16.1053H12.6L14.004 11.2263L16.2 10.4495V7.10526Z"
        fill={theme.palette.brandedTypography.textColor}
      />
    </SvgIcon>
  );
};

export default FinancialReview;
